<template>
  <Form @submit="handleLogin" :validation-schema="schema" class="card-primary max-w-md mx-2 md:mx-auto">

    <TiltedHeader>
      Connexion
    </TiltedHeader>

    <!-- Email -->
    <div class="flex items-center mt-4 border border-secondary rounded bg-background-light">
      <span class="px-3 bg-secondary text-text">
        <EnvelopeIcon class="w-6 h-10 text-white" />
      </span>
      <Field name="email" id="emailInput" type="email"
        class="flex-1 px-3 py-2 bg-background text-text placeholder-secondary outline-none rounded-r"
        placeholder="Entrez votre adresse E-mail" :disabled="message" />
    </div>
    <ErrorMessage name="email" class="text-fun text-sm mt-1" />

    <!-- Password -->
    <div class="flex items-center mt-4 border border-secondary rounded bg-background-light">
      <span class="px-3 bg-secondary text-text">
        <KeyIcon class="w-6 h-10 text-white" />
      </span>
      <Field name="password" id="passwordInput" type="password"
        class="flex-1 px-3 py-2 bg-background text-text placeholder-secondary outline-none rounded-r"
        placeholder="Entrez votre mot de passe" :disabled="message" />
    </div>
    <ErrorMessage name="password" class="text-fun text-sm mt-1" />

    <!-- Forgot password -->
    <a href="#" @click.prevent="openForgotPassword"
      class="tiny-text text-secondary block text-right mt-2 hover:text-accent transition-colors duration-200">
      J'ai oublié mon mot de passe
    </a>

    <!-- Submit button -->
    <button class="btn-primary w-full mt-6 gap-2 flex justify-center items-center" type="submit"
      :disabled="message || loading">

      <!-- Spinner -->
      <span v-if="loading" class="loader-sm mr-2"></span>

      <!-- Icône + texte -->
      <ArrowRightEndOnRectangleIcon v-if="!loading" class="w-6 h-6" />
      <span>{{ loading ? "Connexion en cours..." : "Se connecter" }}</span>
    </button>


    <!-- Flip card -->
    <a href="#" @click.prevent="$emit('flipCard')"
      class="tiny-text text-secondary block text-center mt-6 hover:text-accent transition-colors duration-200">
      Je n'ai pas encore de compte
    </a>

  </Form>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { Form, Field, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import { ref, inject } from 'vue'
import TiltedHeader from '../titles/TiltedHeader.vue'
import { EnvelopeIcon, KeyIcon, ArrowRightEndOnRectangleIcon } from '@heroicons/vue/24/outline'
import MessageComponent from '../ui/MessageComponent.vue'
import ForgotPasswordForm from './ForgotPasswordForm.vue'


const authStore = useAuthStore()
const router = useRouter()

const openOverlay = inject('openOverlay')

const message = ref(null)
const successful = ref(false)
const loading = ref(false)

const schema = yup.object({
  email: yup.string().email().required("Une adresse e-mail est requise"),
  password: yup.string().required("Veuillez entrer un mot de passe"),
})

const handleLogin = async (user, { resetForm }) => {
  loading.value = true
  message.value = null

  try {
    await authStore.login(user)
    successful.value = true
    router.push('/home')
  } catch (error) {
    loading.value = false
    successful.value = false
    if (error.response?.data?.needActivation) {
      message.value = error.response.data.message
      successful.value = false
      openOverlay(MessageComponent, {
        message: message.value,
        successful: successful.value,
        duration: 2000
      })
      setTimeout(() => {
        resetForm()
        message.value = null
        router.push(`/activation-info?email=${encodeURIComponent(user.email)}`)
      }, 2050)
      return
    }
    message.value =
      error.response?.data?.message || error.message || error.toString()
    openOverlay(MessageComponent, { message: message.value, successful: successful.value, duration: 2000 });
    setTimeout(() => {
      resetForm()
      message.value = null
    }, 2050)
  }
}

function openForgotPassword() {
  openOverlay(ForgotPasswordForm, {
    duration: 0
  })
}
</script>

<style>
.tiny-text {
  font-size: 0.9em;
}
</style>
